import { observer } from 'mobx-react';
import React from 'react';

import { Button, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

import useStores from 'hooks/use-stores';

interface Props {
    bulletinType: string;
    privateArea?: boolean;
}

const PrivateArea: React.FC<Props> = ({ bulletinType, privateArea }) => {
    const { userStore, dialogStore } = useStores();

    if (!privateArea || !userStore.userLoaded) {
        return null;
    }

    if (!userStore.isAuthorized) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography>
                    {`This is an article that belongs to ${bulletinType} private collection.`}
                    <br />
                    {' Please sign in to get more Information.'}
                </Typography>
                <Tooltip title="Login">
                    <Button variant="contained" color="primary" onClick={dialogStore.openLoginDialog}>
                        {'Login'}
                    </Button>
                </Tooltip>
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography>
                {`This article is a part of ${bulletinType} private collection that available to extended license holders only. Take a look on our price list or contact our customer support team to get more information about available plans.`}
            </Typography>
            <Box sx={{ marginLeft: '20px' }}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ whiteSpace: 'nowrap', marginBottom: '18px' }}
                    href="/pricing"
                >
                    {'Price List'}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ whiteSpace: 'nowrap' }}
                    href="mailto:sales@vulners.com"
                    target="_blank"
                >
                    {'Contact Us'}
                </Button>
            </Box>
        </Box>
    );
};

export default observer(PrivateArea);
